module.exports = __webpack_public_path__ + "img/project_2.22bf05be.jpg";